export function uid(prefix = '', suffix = '') {
    const uniqueString = Math.random().toString(36).substring(0, 20);
    return `${prefix}${uniqueString}${suffix}`;
}
